import React from 'react';
import TabbedLightbox from '../TabbedLightbox';
import { screen, fireEvent, render } from '@testing-library/react';
import { create } from 'react-test-renderer';

describe('TabbedLightbox', () => {
  it('should render children', () => {
    const labelText = 'test-tab';
    const children = [
      <div aria-label={labelText} name='Tab1' key='1'>
        Content of Tab1
      </div>,
    ];
    render(<TabbedLightbox onClose={() => {}} children={children} className='test-class' />);
    expect(screen.getByLabelText(labelText)).toBeInTheDocument();
  });

  it('selected props should work & change based on selection', () => {
    const firstTabContent = 'Content of Tab1';
    const secondTabContent = 'Content of Tab2';
    const children = [<div key='1' name='Tab1'>{firstTabContent}</div>, <div key='2' name='Tab2'>{secondTabContent}</div>];
    render(<TabbedLightbox onClose={() => {}} children={children} className='test-class' selected={0} />);
    expect(screen.queryByText(firstTabContent)).toBeDefined();
    expect(screen.queryByText(secondTabContent)).not.toBeInTheDocument();
    fireEvent.click(screen.getAllByRole('button').at(1));
    expect(screen.queryByText(firstTabContent)).not.toBeInTheDocument();
    expect(screen.queryByText(secondTabContent)).toBeDefined();
  });

  it('should show given id', () => {
    const children = [<div key='1' name='Tab1'>Content of Tab1</div>, <div key='2' name='Tab2'>Content of Tab2</div>];
    render(<TabbedLightbox onClose={() => {}} className='test-class' children={children} id={123} />);
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === '123')).toBeInTheDocument();
  });

  describe('snapshots', () => {
    const children = [<div key='1' name='Tab1'>Content of Tab1</div>, <div key='2' name='Tab2'>Content of Tab2</div>];
    const fields = [
      {
        name: 'Created',
        value: '2017-01-10 09:17:00',
      },
      {
        name: 'Last Updated',
        value: '2017-01-11 11:30:12',
      },
    ];

    it('should match default snapshot', () => {
      const component = create(<TabbedLightbox onClose={() => {}} children={children} />).toJSON();
      expect(component).toMatchSnapshot();
    });
    it('should match given title, id with fields snapshot', () => {
      const component = create(
        <TabbedLightbox onClose={() => {}} children={children} className='test-class' fields={fields} id={12} title='Title' />
      ).toJSON();
      expect(component).toMatchSnapshot();
    });
    it('should match given closeOnClickOutside snapshot', () => {
      const component = create(
        <TabbedLightbox onClose={() => {}} children={children} className='test-class' closeOnClickOutside={false} />
      ).toJSON();
      expect(component).toMatchSnapshot();
    });
    it('should match given selected tab snapshot', () => {
      const component = create(<TabbedLightbox onClose={() => {}} children={children} className='test-class' selected={1} />).toJSON();
      expect(component).toMatchSnapshot();
    });
    it('should match all props given snapshot', () => {
      const component = create(
        <TabbedLightbox
          onClose={() => {}}
          children={children}
          className='test-class'
          closeOnClickOutside={false}
          fields={fields}
          id={12}
          level={3}
          selected={1}
          title='Title'
          cover='https://images-na.ssl-images-amazon.com/images/M/MV5BMTA1ODgxNDAwNDVeQTJeQWpwZ15BbWU4MDIxMjg1NzIx._V1_SY1000_CR0,0,1422,1000_AL_.jpg'
        />
      ).toJSON();
      expect(component).toMatchSnapshot();
    });
  });
});
